import { render } from "./Login.vue?vue&type=template&id=abada47e&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=abada47e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abada47e"]])

export default __exports__